import { ProjectConfig } from '../../interface/project.interface';

export const project: ProjectConfig = {
    version: '5.4.0',
    buildNumber: '0',
    mobileApiPath: 'sbg-mobile/rest',
    accountsFeatureKey: 'sbsa-accounts'
};

export const scopes = {
    PLATFORM_ALL: 'sbg-platform.all',
    CORE_CUSTOMER_PLATFORM: 'sbg-corecustomerplatform.all',
    PAYMENTS: 'sbg-payment.all',
    OPEN_ID: 'openid',
    PROFILE: 'profile',
    DEVICE: 'device',
    EMAIL: 'email',
    CARDS: 'card-domain.*.*',
    SURVEY: 'surveyservice.*.*',
    MESSAGING: 'messaging.*.*',
    PING_IDENTITY: 'urn:pingidentity:directory-api'
};
export const channel = 'WEB';
